import React, { JSX } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { getAccessToken } from "api/APIClient";

export default function PrivateRoute({
  children,
}: {
  children: JSX.Element;
}) {
  const location = useLocation();
  const accessToken = getAccessToken();

  if (!accessToken) {
    return (
      <Navigate
        to="/login/"
        replace
        state={{ from: location }}
      />
    );
  }

  return children;
}